/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card rating instance
 *
 * @module enervee_utils.product_card
 */
function productCardRatingDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '=',
        },
        controller: productCardRatingController,
        template: require('./ratingView.html')
    };
}

productCardRatingController.$inject = ['$scope', 'UtilService'];
function productCardRatingController($scope, UtilService) {
    var vm = this;

    $scope.icon = UtilService.getIconClass('rating', 'star');
}

module.exports = productCardRatingDirective;